module.exports = __webpack_public_path__ + "images/fd9fc873716c8b2a581f7ddfaa6079a2.svg";